import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import { Grid } from "@material-ui/core";
import invitesActions from "./actions";
import PreviewTile from "components/common/PreviewTile";
import Header from "components/User/Header";

const InvitesOverview = () => {
  const { breakDown } = useSelector((state) => state.invites);
  const { loadInviteBreakDown } = invitesActions();
  useEffect(() => {
    loadInviteBreakDown();
  }, [loadInviteBreakDown]);

  return (
    <>
      <Header>Invites</Header>
      <Grid container justify="flex-start">
        {[{ h: "Invites", c: breakDown && breakDown.count }].map((value) => (
          <PreviewTile title={value.h} text={String(value.c)} key={value.h} />
        ))}
      </Grid>
    </>
  );
};

export default InvitesOverview;
